import { makeAutoObservable, observable } from 'mobx';
import { CampaignGroupsCrudStore } from './campaign-groups-crud.store';
import { IPerformanceOptions } from '../../hooks/apis/use-reports-list';
import { PerformanceResponse } from '../../models/performance.model';
import { SettingsStore } from '@monorepo/controlled/src/stores/settings.store';
import { TableStore } from '@monorepo/controlled/src/stores/table.store';
import { FilterStore, FiltersMap } from '@monorepo/controlled/src/stores/filter.store';
import { campaignGroupsFilterPrototypes, filterPrototypesByProp } from '../../components/filters-menu/filters/index';
import { FilterModel } from '@monorepo/controlled/src/models/filter.model';
import { Statuses } from '../../enums/status';
import { StringActions } from '@monorepo/tools/src/lib/utils/string';
import { PerformanceApi } from '../../apis/performance.api';
import { HttpStore } from '@monorepo/controlled/src/stores/http.store';
import { NewAdminxReportTableStore } from '../../components/report-table/stores/table-stores/adx-repr-table.store';
import { campaignGroupsTableConfig } from '../../components/report-table/configurations/adx-repr/campaign-groups/campaign-groups.config';
import { campaignGroupsAdvertiserTableConfig } from '../../components/report-table/configurations/adx-repr/campaign-groups/campaign-groups.advertiser.config';

export enum CampaignGroupFiltersStoreKeys {
	CampaignGroups = 'campaigngroups',
}

export class CampaignGroupsStore {
	crud = new CampaignGroupsCrudStore();
	list = new HttpStore<IPerformanceOptions, PerformanceResponse>({
		httpFunc: PerformanceApi.performance,
		model: PerformanceResponse,
	});
	metrics = new HttpStore<IPerformanceOptions, PerformanceResponse>({
		httpFunc: PerformanceApi.performance,
		model: PerformanceResponse,
	});

	campaignGroupsPerformance = new NewAdminxReportTableStore(campaignGroupsTableConfig);
	campaignGroupsAdvertiserPerformance = new NewAdminxReportTableStore(campaignGroupsAdvertiserTableConfig);

	settingsStore: SettingsStore;

	constructor(settingsStore: SettingsStore) {
		makeAutoObservable(this, {
			crud: observable,
			list: observable,
			metrics: observable,
			campaignGroupsPerformance: observable,
		});
		this.settingsStore = settingsStore;
		this.createDefaultFilters();
	}

	createDefaultFilters() {
		const prototype = campaignGroupsFilterPrototypes.find(filter => filter.MenuComponent === 'Status');
		let defaultFilters: FiltersMap;
		if (prototype) {
			defaultFilters = new Map([
				[
					1,
					new FilterModel({
						index: 1,
						label: `Status is ${Statuses.Active}`,
						action: StringActions.Equals,
						value: [Statuses.Active],
						prototype,
					}),
				],
			]);
		}
		Object.values(CampaignGroupFiltersStoreKeys).map((key: CampaignGroupFiltersStoreKeys) => {
			if (!this.settingsStore.getPages().get(key)) {
				this.settingsStore.getPages().set(key, { tableStore: new TableStore() });
			}
			const campaignGroupFilterByKey = new FilterStore({
				key,
				currentFilters: defaultFilters,
				filterPrototypesByProp,
			});
			this.settingsStore.getPages().get(key)?.tableStore.setFiltersStore(key, campaignGroupFilterByKey);
		});
	}

	getCrud() {
		return this.crud;
	}

	getListStore() {
		return this.list;
	}

	getMetrics() {
		return this.metrics;
	}
}
